import { ArrowLeft } from "lucide-react";

const Section = ({ title, children, id }) => (
  <section data-testid={`legal-section-${id}`} className="mt-10">
    <h2 className="font-heading text-xl font-bold text-slate-900">{title}</h2>
    <div className="mt-3 space-y-3 text-sm sm:text-base text-slate-600 leading-relaxed">{children}</div>
  </section>
);

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-sky-100">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-[72px] flex items-center justify-between">
          <a href="/" data-testid="legal-logo" className="flex items-center">
            <img src="/logo.png" alt="WM Clean" className="h-10 w-auto" />
          </a>
          <a
            href="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-sky-600 transition-colors"
          >
            <ArrowLeft size={15} /> Retour au site
          </a>
        </div>
      </header>

      <main data-testid="legal-page" className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">
          Mentions légales & Politique de confidentialité
        </h1>
        <p className="mt-3 text-sm text-slate-500">Dernière mise à jour : juillet 2026</p>

        <Section title="1. Éditeur du site" id="editeur">
          <p>
            Le site wmclean-lille.fr est édité par <strong>WM Clean</strong>, entreprise de nettoyage
            de vitres pour particuliers et professionnels, intervenant à Lille et dans la métropole
            lilloise.
          </p>
          <p>
            Téléphone : <a href="tel:+33638474300" className="text-sky-600 font-semibold">06 38 47 43 00</a>
            <br />
            Email : <a href="mailto:cleanwmpro@gmail.com" className="text-sky-600 font-semibold">cleanwmpro@gmail.com</a>
            <br />
            SIRET : 990 941 254 00015
          </p>
          <p>Directeur de la publication : le gérant de WM Clean.</p>
        </Section>

        <Section title="2. Hébergement" id="hebergement">
          <p>
            Ce site est hébergé sur l'infrastructure cloud de la plateforme Emergent
            (emergent.sh), serveurs situés dans l'Union européenne.
          </p>
        </Section>

        <Section title="3. Propriété intellectuelle" id="propriete">
          <p>
            L'ensemble des contenus du site (logo, textes, visuels, charte graphique) est la
            propriété exclusive de WM Clean, sauf mention contraire. Toute reproduction ou
            réutilisation sans autorisation écrite préalable est interdite.
          </p>
        </Section>

        <Section title="4. Données personnelles (RGPD)" id="rgpd">
          <p>
            Dans le cadre de sa demande de devis, WM Clean collecte les données suivantes via son
            formulaire de contact : nom, numéro de téléphone, adresse email, adresse postale, type
            de bien, message et, le cas échéant, une photographie transmise volontairement.
          </p>
          <p>
            <strong>Finalité :</strong> ces données sont utilisées exclusivement pour traiter votre
            demande de devis et vous recontacter. Elles ne font l'objet d'aucune prospection
            commerciale sans votre accord et ne sont ni vendues ni transmises à des tiers.
          </p>
          <p>
            <strong>Base légale :</strong> mesures précontractuelles (article 6.1.b du RGPD) —
            la demande de devis émane de vous.
          </p>
          <p>
            <strong>Durée de conservation :</strong> les demandes non suivies d'une prestation sont
            conservées au maximum 12 mois, puis supprimées. Les données des clients sont conservées
            pendant la durée de la relation commerciale, augmentée des délais légaux de
            prescription.
          </p>
          <p>
            <strong>Vos droits :</strong> conformément au RGPD et à la loi Informatique et
            Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement, de
            limitation et d'opposition concernant vos données. Pour les exercer, écrivez à{" "}
            <a href="mailto:cleanwmpro@gmail.com" className="text-sky-600 font-semibold">cleanwmpro@gmail.com</a>{" "}
            ou appelez le 06 38 47 43 00. Vous pouvez également introduire une réclamation auprès
            de la CNIL (cnil.fr).
          </p>
        </Section>

        <Section title="5. Cookies" id="cookies">
          <p>
            Ce site n'utilise pas de cookie publicitaire ni de traceur de navigation à des fins
            marketing. Seuls des cookies techniques strictement nécessaires au fonctionnement du
            site (notamment la session de l'espace professionnel) sont déposés.
          </p>
        </Section>

        <Section title="6. Responsabilité" id="responsabilite">
          <p>
            Les informations et tarifs présentés sur ce site sont donnés à titre indicatif et ne
            constituent pas une offre contractuelle. Chaque prestation fait l'objet d'un devis
            gratuit et personnalisé. WM Clean ne saurait être tenu responsable des dommages
            indirects liés à l'utilisation du site.
          </p>
        </Section>
      </main>

      <footer className="border-t border-slate-200 py-8 text-center text-xs text-slate-400">
        © 2026 WM Clean — Nettoyage de vitres à Lille. Tous droits réservés.
      </footer>
    </div>
  );
}
